/**
 * @class CartConfig
 * @description Manages cart endpoint configuration and validation
 */
class CartConfig {
  static ENDPOINTS = {
    add: ['/cart/add'],
    change: ['/cart/change'],
    update: ['/cart/update']
  }

  /**
     * @param {string} url - URL to check
     * @returns {boolean} Whether URL is a cart endpoint
     */
  isCartEndpoint(url) {
    return Object.values(CartConfig.ENDPOINTS).some((endpoints) => endpoints.some((endpoint) => url.includes(endpoint)))
  }

  /**
     * @param {string} url - URL to check
     * @returns {string|null} Type of endpoint or null if not found
     */
  getEndpointType(url) {
    return (
      Object.entries(CartConfig.ENDPOINTS).find(([_, endpoints]) =>
        endpoints.some((endpoint) => url.includes(endpoint))
      )?.[0] || null
    )
  }
}

export default CartConfig
